import { AxiosError } from 'axios';
import { PUT_UPDATE_AUDIT_SETTINGS_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';

// =============================================================================
// Request & Response Model
// =============================================================================

export interface AuditSettingsRequest {
  uuid: string;
  firstGeneratedDate: string;
  repeat: string;
  reviewDeadLine: number;
  reminderReviewRepeat: string;
}

export interface AuditSettingsResponse {}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  reportType: string;
  onSuccess?: (data: AuditSettingsResponse) => void;
  onError?: (err: AxiosError) => void;
}

export const usePutAuditSettings = ({ onSuccess, onError, reportType }: Input) => {
  const putAuditSettings = async (payload: AuditSettingsRequest) => {
    const res = await axiosClient.put<AuditSettingsResponse>(
      PUT_UPDATE_AUDIT_SETTINGS_URL(reportType),
      payload
    );
    return res.data;
  };

  return useCustomMutation(putAuditSettings, {
    onSuccess,
    onError,
  });
};
